import { FC, useCallback, useEffect } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { Container } from '@material-ui/core';
import { useStyles } from './styles';
import { authorizedRoutes, publicRoutes } from '../../config/routing';
import AuthorizedRoute from '../AuthorizedRoute';
import PublicRoute from '../PublicRoute';

import {
    SET_LOADING_USER,
    thunkGetCurrentUser,
    thunkGetInfluencerInfo,
} from '../../store/actions/CurrentUser.actions';
import { Token } from '../../models/enums/Token';
import { useLocalStorage } from '../../config/hooks/useLocalStorage';
import { thunkGetCurrentEvent } from '../../store/actions/Streaming.actions';
import { thunkGetLanguages } from '../../store/actions/Languages.actions';
import { thunkGetAllCategories } from '../../store/actions/Categories.actions';
import { UserRolesNumeric } from '../../models/enums/UserRoles';

const App: FC = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [token] = useLocalStorage(Token.TOKEN, null);

    const updateInfluencerInfo = useCallback(
        (userRole: UserRolesNumeric) => {
            if (userRole === UserRolesNumeric.INFLUENCER) {
                dispatch(thunkGetInfluencerInfo());
            }
        },
        [dispatch],
    );

    useEffect(() => {
        if (token) {
            dispatch(thunkGetCurrentUser(updateInfluencerInfo));
        } else {
            dispatch({ type: SET_LOADING_USER, payload: false });
        }

        dispatch(thunkGetCurrentEvent());
        dispatch(thunkGetLanguages());
        dispatch(thunkGetAllCategories());
    }, [dispatch, token, updateInfluencerInfo]);

    return (
        <Router>
            <div className={classes.app}>
                <Container component="main" maxWidth={false} className={classes.main}>
                    <Switch>
                        {publicRoutes.map(route => (
                            <PublicRoute
                                key={route.path}
                                path={route.path}
                                exact={route.exact}
                                component={route.component}
                            />
                        ))}
                        {authorizedRoutes.map(route => (
                            <AuthorizedRoute
                                path={route.path}
                                component={route.component}
                                key={route.path}
                                exact={route.exact}
                                requiredRoles={route.requiredRoles}
                            />
                        ))}
                    </Switch>
                </Container>
            </div>
        </Router>
    );
};

export default App;
